<script>
import Banner from 'dashboard/components/ui/Banner.vue';

export default {
  components: { Banner },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['dismiss'],
  methods: {
    handleReload() {
      window.location.reload();
    },
    handleDismiss() {
      this.$emit('dismiss');
    },
  },
};
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <Banner
    v-if="show"
    color-scheme="primary"
    :banner-message="$t('GENERAL_SETTINGS.NEW_VERSION_AVAILABLE')"
    has-action-button
    action-button-variant="solid"
    :action-button-label="$t('GENERAL_SETTINGS.RELOAD_NOW')"
    action-button-icon="i-lucide-refresh-cw"
    has-close-button
    @primary-action="handleReload"
    @close="handleDismiss"
  />
</template>
